export default {
  name: 'KnMiniFooter'
}